import { isRejectedWithValue, Middleware } from "@reduxjs/toolkit";
import { OvstErrorCode } from "../../shared/oversight-core/enums/ovst-error-codes";
import { IHttpError } from "../../shared/oversight-core/interfaces/http-errror";
import { setPrivileges, setToken } from "../features/auth/auth-slice";
import { resetProfile } from "../features/user/user-slice";

export const rtkQueryErrorLogger: Middleware = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    const error = action.payload as IHttpError;
    switch (error.status) {
      case 500:
        console.log(error);
        break;
      case 401:
        if (error.ovstErrorCode === OvstErrorCode.OVST_SEC_0001) {
          // showErrorMessage(
          //   "Session Expired. Please Login Again",
          //   "session-expired"
          // );
          const country = localStorage.getItem("country");
          localStorage.clear();
          api.dispatch(setToken(""));
          api.dispatch(setPrivileges([]));
          api.dispatch(resetProfile());

          if (country !== null) {
            localStorage.setItem("country", country);
          }
        }
        break;
      default:
        break;
    }
  }

  return next(action);
};
